import * as R from "ramda";
import { Typography } from "antd";
import { message, Switch } from "antd";
import { Subject, distinctUntilChanged } from "rxjs";
import React, { Fragment, useEffect, useState } from "react";

import {
  batchHidden,
  mediaSourcesSaveOne,
  getResourceDetailApi,
} from "../aliyun-service-api";
import { updateOneMediaSourceById } from "./list-item";
import { UploadImageByStringUrl } from "./upload-resource";
import { BaseTypeCarouselItemText } from "./base-type-carousel-item-text";
import { BaseTypeCarouselItemAudio } from "./base-type-carousel-item-audio";
import { BaseTypeCarouselItemImage } from "./base-type-carousel-item-image";
import { BaseTypeCarouselItemVideo } from "./base-type-carousel-item-video";

import "./base-type-carousel-item.scss";

const { Paragraph } = Typography;

export const getDetail = (item) => {
  return getResourceDetailApi(item.id);
};

export const BaseEdit = (props) => {
  const { detail, typeName } = props;
  return (
    <div onKeyDown={(e) => e.stopPropagation()}>
      <Paragraph
        key={R.pathOr("", [typeName], detail)}
        editable={{
          onChange(val) {
            const id = R.pathOr("", ["id"], detail);
            mediaSourcesSaveOne(id, { [typeName]: val }).then(
              (res) => {
                //  保存成功
                message.success("保存成功");
                const updateOne = R.pathOr(R.T, ["updateOne"], props);
                updateOne(res);
              },
              () => {
                //  保存失败
                message.error("保存失败");
              }
            );
          },
        }}
      >
        {R.pathOr("", [typeName], detail)}
      </Paragraph>
    </div>
  );
};

export const EditName = (props) => {
  return <BaseEdit {...props} typeName="name" />;
};

export const EditCover = (props) => {
  const detail = R.pathOr({}, ["detail"], props);
  const options = R.pathOr({}, ["options"], detail);
  const coverUrl = R.pathOr("", ["coverUrl"], options);

  const [subject$] = useState(new Subject());

  useEffect(() => {
    const subscription = subject$
      .pipe(distinctUntilChanged())
      .subscribe((newCoverUrl) => {
        const id = R.pathOr("", ["id"], detail);
        mediaSourcesSaveOne(id, {
          options: {
            ...options,
            coverUrl: newCoverUrl,
          },
        }).then(
          (res) => {
            //  保存成功
            const updateOne = R.pathOr(R.T, ["updateOne"], props);
            //  这样做的目的是上传到阿里云后, 立即更新封面会出现封面未更新的情况, 因为阿里云上传是异步的
            setTimeout(() => {
              updateOne(res);
            }, 1000);
          },
          () => {
            //  保存失败
            message.error("保存失败");
          }
        );
      });

    return () => {
      subscription.unsubscribe();
    };
  }, []);
  return (
    <UploadImageByStringUrl
      {...props}
      value={coverUrl}
      onChange={(newCoverUrl) => {
        subject$.next(newCoverUrl);
      }}
    />
  );
};

export const EditDesc = (props) => {
  return <BaseEdit {...props} typeName="desc" />;
};

export const VisibleSwitch = (props) => {
  const { detail = {}, updateOne = R.T, size = "default" } = props;
  //  0=>公开 1=>未公开
  const { hidden = 1 } = detail;
  return (
    <Fragment>
      <style>
        {`
          .bg-white[role=switch]>span.ant-switch-inner {
            color: black;
          }
          `}
      </style>
      <Switch
        size={size}
        className={hidden ? "bg-white" : "bg-green"}
        checked={hidden === 0}
        checkedChildren={"公开"}
        unCheckedChildren={"未公开"}
        onChange={(checked) => {
          batchHidden(detail.order_id, [detail.id], checked ? 0 : 1).then(
            () => {
              //  更新成功
              message.success("更新成功");
              updateOneMediaSourceById(detail.id, updateOne);
            },
            () => {
              //  更新失败
              message.error("更新失败");
            }
          );
        }}
      />
    </Fragment>
  );
};

export const BaseTypeCarouselItem = (props) => {
  const type = R.pathOr("", ["detail", "type"], props);

  return (
    <div className="base-type-carousel-item" onMouseDown={(e) => e.stopPropagation()}>
      {(() => {
        switch (type) {
          case "video":
            return <BaseTypeCarouselItemVideo {...props} />;
          case "image":
            return <BaseTypeCarouselItemImage {...props} />;
          case "audio":
            return <BaseTypeCarouselItemAudio {...props} />;
          case "text":
            return <BaseTypeCarouselItemText {...props} />;
          default:
            return <Fragment />;
        }
      })()}
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/containers/Video/widgets/base-type-carousel-item.js